import { ClientOrganization } from '@graphql';
import { CustomChip } from '@components';
import { Typography } from '@mui/material';
import { useMemo } from 'react';
import { COLORS } from '@styles';

interface IOrganizationInfoProps {
  organization?: ClientOrganization;
}

const styles = {
  organizationInfoContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '1rem',
  } as React.CSSProperties,
  organizationInfoItem: {
    display: 'flex',
    flexDirection: 'column',
    color: COLORS.NEUTRAL_LIGHT_3,
  } as React.CSSProperties,
  organizationName: {
    fontSize: '1.25rem',
    fontWeight: 600,
  } as React.CSSProperties,
  organizationAdminEmail: {
    fontSize: '0.875rem',
    fontWeight: 400,
    color: COLORS.NEUTRAL_LIGHT_0,
  }
};

export function OrganizationInfo({ organization }: IOrganizationInfoProps) {

  const organizationName = useMemo(() => `${organization?.name}`, [organization]);
  const organizationAdminEmail = useMemo(() => organization?.adminClient?.email, [organization]);
  const organizationTier = useMemo(() => organization?.currentTier?.name, [organization]);


  return (
    <div style={styles.organizationInfoContainer}>
      <div style={styles.organizationInfoItem}>
        <Typography variant='h6' style={styles.organizationName}>{organizationName || ''}</Typography>
        <Typography variant='body1' style={styles.organizationAdminEmail}>{organizationAdminEmail || ''}</Typography>
      </div>
      <CustomChip label={organizationTier || ''} variant='default' />
    </div>
  );
}